import { useMutation } from '@tanstack/react-query'

import { downloadTenantShipmentsCsv } from 'repositories/ShipmentApi/downloadTenantShipmentsCsv'
import type { DownloadTenantShipmentsCsvParams } from 'repositories/ShipmentApi/downloadTenantShipmentsCsv/type'

import { saveCsvBlob } from '../../utils/saveCsvBlob'

export type DownloadShipmentsCsvArgs = DownloadTenantShipmentsCsvParams & {
  fallbackFilename: string
}

export const useDownloadShipmentsCsv = () =>
  useMutation({
    mutationFn: async ({ fallbackFilename, ...params }: DownloadShipmentsCsvArgs) => {
      const { blob, filename } = await downloadTenantShipmentsCsv(params)
      saveCsvBlob(blob, filename ?? fallbackFilename)
    },
  })
